var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.190002,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#B22539",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.251 41.4998L28.751 41.4998V38.9998L51.251 38.9998V41.4998ZM28.751 47.7498H51.251V45.2498H28.751V47.7498ZM51.251 53.9998H28.751V51.4998H51.251V53.9998Z",
    fill: "#B22539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.251 33.9998C21.251 33.3367 21.5144 32.7008 21.9832 32.232C22.452 31.7632 23.0879 31.4998 23.751 31.4998H26.251V30.2498C26.251 22.656 32.4072 16.4998 40.001 16.4998C47.5947 16.4998 53.751 22.656 53.751 30.2498V31.4998H56.251C56.914 31.4998 57.5499 31.7632 58.0187 32.232C58.4876 32.7008 58.751 33.3367 58.751 33.9998L58.751 58.9998C58.751 59.6628 58.4876 60.2987 58.0187 60.7675C57.5499 61.2364 56.914 61.4998 56.251 61.4998L23.751 61.4998C23.0879 61.4998 22.452 61.2364 21.9832 60.7675C21.5144 60.2987 21.251 59.6628 21.251 58.9998L21.251 33.9998ZM51.251 30.2498C51.251 27.2661 50.0657 24.4046 47.9559 22.2948C45.8461 20.185 42.9847 18.9998 40.001 18.9998C37.0173 18.9998 34.1558 20.185 32.046 22.2948C29.9362 24.4046 28.751 27.2661 28.751 30.2498V31.4998H31.251V30.2498C31.251 29.1007 31.4773 27.9629 31.917 26.9013C32.3567 25.8397 33.0013 24.8751 33.8138 24.0626C34.6263 23.2501 35.5909 22.6055 36.6525 22.1658C37.7141 21.7261 38.8519 21.4998 40.001 21.4998C41.15 21.4998 42.2879 21.7261 43.3495 22.1658C44.411 22.6055 45.3756 23.2501 46.1882 24.0626C47.0007 24.8751 47.6452 25.8397 48.0849 26.9013C48.5246 27.9629 48.751 29.1007 48.751 30.2498V33.9998L23.751 33.9998L23.751 58.9998L56.251 58.9998L56.251 33.9998H51.251V30.2498ZM40.001 23.9998C38.3434 23.9998 36.7537 24.6582 35.5815 25.8303C34.4094 27.0024 33.751 28.5922 33.751 30.2498V31.4998L46.251 31.4998V30.2498C46.251 28.5922 45.5925 27.0024 44.4204 25.8303C43.2483 24.6582 41.6586 23.9998 40.001 23.9998Z",
    fill: "#B22539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy3);
export default __webpack_public_path__ + "static/media/why3.5c80066cf7e5813024718fd1ede36ee2.svg";
export { ForwardRef as ReactComponent };